import { render } from "./PointUnitEditView.vue?vue&type=template&id=19ddafcc&scoped=true"
import script from "./PointUnitEditView.vue?vue&type=script&lang=js"
export * from "./PointUnitEditView.vue?vue&type=script&lang=js"

import "./PointUnitEditView.vue?vue&type=style&index=0&id=19ddafcc&scoped=true&lang=css"

import exportComponent from "/Users/mae/Dev/mamp/htdocs/mfj_renewal/manage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ddafcc"]])

export default __exports__